import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vitrine-footer',
  templateUrl: './vitrine-footer.component.html',
  styleUrls: ['./vitrine-footer.component.scss'],
})
export class VitrinenFooterComponent {
  currentYear = new Date().getFullYear();

  constructor(private router: Router) {}

  goToContact(): void {
    this.router.navigate(['/public/contact']);
  }

  goToRegister(): void {
    this.router.navigate(['/login']);
  }
}
